export interface CsvToolColumnConfig<T> {
  header: string;
  key?: keyof T;
  valueGetter?: (row: T) => string | number;
}

export const csvTool = <T>(columnConfig: Array<CsvToolColumnConfig<T>>, data: Array<T>): string => {
  let output = columnConfig.map((column) => column.header).join(',') + '\n';
  data.forEach((row) => {
    output +=
      columnConfig
        .map((column) => {
          if (column.key) {
            if (!row[column.key]) {
              return '';
            }
            return String(row[column.key]).replace(/(\r\n|\n|\r|,)/gm, '');
          }

          if (column.valueGetter) {
            return String(column.valueGetter(row)).replace(/(\r\n|\n|\r|,)/gm, '');
          }

          return '';
        })
        .join(',') + '\n';
  });
  return output;
};
